import { Sidebar } from "../components/Sidebar";
import { Navbar } from "../components/Navbar";


export default function DashboardLayout({ children }) {
return (
<div className="flex">
<Sidebar />


<main className="flex-1 p-6 bg-gray-50 min-h-screen">
<Navbar />
<div className="mt-6">{children}</div>
</main>
</div>
);
}